export default __webpack_public_path__ + "18e7fdd45099134897d268bcf235f845.svg";